import React from "react";
import { Row, Col } from "antd";
import AsyncTextInput from "../../../CommonFormItems/AsyncTextInput/AsyncTextInput";
import SelectInput from "../../../CommonFormItems/SelectInput/SelectInput";
import TextInput from "../../../CommonFormItems/TextInput/TextInput";
import CheckboxInput from "../../../CommonFormItems/CheckboxInput/CheckboxInput";
import moment from "moment";
import FarmaDateTimePicker from "../../../CommonFormItems/FarmaDateTimePicker/FarmaDateTimePicker";

export default function StandardShipmentForm({
  form,
  shipmentDetails,
  handleShipmentDetails,
  handleImeiDetails,
  handleImeiInputChange,
  handleTrazability,
  imeiDetails,
  hasSpecialRole,
  hasRecipientSpecialPostCode,
  checkValidDataLogger,
  searchOptions,
  paqFarmaProduct,
}) {
  const { getFieldDecorator, setFields, setFieldsValue, getFieldValue } = form;

  const now = moment();
  const minDate = moment().subtract(72, "hours");

  return (
    <>
      <Row
        type="flex"
        justify="space-between"
        gutter={[16, 16]}
        className="pr-grid-row"
      >
        <Col xs={24} md={7} className="pr-col">
          <AsyncTextInput
            form={form}
            getFieldDecorator={getFieldDecorator}
            setFields={setFields}
            name="imei"
            label="Referencia IMEI - Matrícula de la Caja"
            placeholder="Ej: 123456789012345"
            callback={handleImeiDetails}
            onValueChange={handleImeiInputChange}
            errorMessage="No se ha encontrado un IMEI con ese valor."
            required
            requiredMessage="Campo obligatorio"
            pattern={/^[^\s]{1,15}$/}
            patternMessage="Valor no válido. No se permiten espacios."
          />
        </Col>
        <Col xs={24} md={7} className="pr-col pr-col-offset">
          <SelectInput
            getFieldDecorator={getFieldDecorator}
            label="Trazabilidad de la temperatura"
            name="temperatureTraceabilityID"
            options={searchOptions?.tempTrazabilityList}
            disabled={false}
            placeholder="Seleccione un tipo de trazabilidad..."
            labelInValue
            preLoadedData
            required
            callback={handleTrazability}
          />
        </Col>
        <Col xs={24} md={7} className="pr-col pr-col-offset">
          {shipmentDetails.mustShowDataLogger &&
            (shipmentDetails.mustFillDatalogger ? (
              <TextInput
                label="Código de datalogger"
                getFieldDecorator={getFieldDecorator}
                name="dataLoggerID"
                initialValue={imeiDetails?.imei || null}
                disabled
                required={false}
                requiredMessage="Campo obligatorio"
                placeholder="Introduzca un código de datalogger"
                pattern={/^[^\s]{1,15}$/}
                patternMessage="Valor no válido. No se permiten espacios."
              />
            ) : (
              <AsyncTextInput
                form={form}
                getFieldDecorator={getFieldDecorator}
                setFields={setFields}
                name="dataLoggerID"
                label="Código de datalogger"
                placeholder="Introduzca un código de datalogger"
                callback={checkValidDataLogger}
                errorMessage="No se ha encontrado un datalogger con ese valor."
                pattern={/^[^\s]{1,15}$/}
                patternMessage="Valor no válido. No se permiten espacios."
              />
            ))}
        </Col>
      </Row>

      <Row
        type="flex"
        justify="space-between"
        gutter={[16, 16]}
        className="pr-grid-row"
      >
        <Col xs={24} md={5} className="pr-col">
          <TextInput
            label="Peso (g)"
            getFieldDecorator={getFieldDecorator}
            name="weight"
            initialValue={imeiDetails?.weight}
            disabled
            required
            requiredMessage="Campo obligatorio"
            placeholder="Introduzca IMEI para obtener valor"
            pattern={/^\d+(\.\d{1,2})?$/}
          />
        </Col>
        <Col xs={24} md={5} className="pr-col pr-col-offset">
          <TextInput
            label="Largo (mm)"
            getFieldDecorator={getFieldDecorator}
            name="length"
            initialValue={imeiDetails?.length}
            disabled
            required
            requiredMessage="Campo obligatorio"
            placeholder="Introduzca IMEI para obtener valor"
            pattern={/^\d+(\.\d{1,2})?$/}
          />
        </Col>
        <Col xs={24} md={5} className="pr-col pr-col-offset">
          <TextInput
            label="Ancho (mm)"
            getFieldDecorator={getFieldDecorator}
            name="width"
            initialValue={imeiDetails?.width}
            disabled
            required
            requiredMessage="Campo obligatorio"
            placeholder="Introduzca IMEI para obtener valor"
            pattern={/^\d+(\.\d{1,2})?$/}
          />
        </Col>
        <Col xs={24} md={5} className="pr-col pr-col-offset">
          <TextInput
            label="Alto (mm)"
            getFieldDecorator={getFieldDecorator}
            name="height"
            initialValue={imeiDetails?.height}
            disabled
            required
            requiredMessage="Campo obligatorio"
            placeholder="Introduzca IMEI para obtener valor"
            pattern={/^\d+(\.\d{1,2})?$/}
          />
        </Col>
      </Row>

      {hasSpecialRole && hasRecipientSpecialPostCode && (
        <Row
          type="flex"
          justify="space-between"
          gutter={[16, 16]}
          className="pr-grid-row"
        >
          <Col xs={24} md={5} className="pr-col">
            <TextInput
              label="Número tarifario"
              getFieldDecorator={getFieldDecorator}
              name="tariffNumber"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 821599"
              pattern={/^[^\s]{1,15}$/}
              patternMessage="Valor no válido. No se permiten espacios."
            />
          </Col>
          <Col xs={24} md={3} className="pr-col pr-col-offset">
            <TextInput
              label="Valor neto (€)"
              getFieldDecorator={getFieldDecorator}
              name="netValue"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 3.85"
              pattern={/^\d+(\.\d{1,2})?$/}
              patternMessage="Valor no válido."
            />
          </Col>
          <Col xs={24} md={3} className="pr-col pr-col-offset">
            <TextInput
              label="Peso neto (kg)"
              getFieldDecorator={getFieldDecorator}
              name="netWeight"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 2.48"
              pattern={/^\d+(\.\d{1,3})?$/}
              patternMessage="Valor no válido."
            />
          </Col>
          <Col xs={24} md={3} className="pr-col pr-col-offset">
            <TextInput
              label="Cantidad"
              getFieldDecorator={getFieldDecorator}
              name="quantity"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 10"
              pattern={/^[0-9]+$/}
              patternMessage="Valor no válido."
            />
          </Col>
          <Col xs={24} md={5} className="pr-col pr-col-offset">
            <TextInput
              label="Descripción"
              getFieldDecorator={getFieldDecorator}
              name="description"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: BABY_BOTTLE Item"
              pattern={/^(?! ).*(?<! )$/}
              patternMessage="Valor no válido. No espacios inicio/fin."
            />
          </Col>
        </Row>
      )}

      <Row
        type="flex"
        justify="space-between"
        gutter={[16, 16]}
        className="pr-grid-row"
      >
        {paqFarmaProduct ? (
          <>
            {/* Referencia del cliente */}
            <Col xs={24} md={5} className="pr-col">
              <TextInput
                label="Referencia del cliente"
                getFieldDecorator={getFieldDecorator}
                name="clientReference"
                placeholder="Introduzca una referencia de cliente"
              />
            </Col>

            {/* Observaciones */}
            <Col xs={24} md={5} className="pr-col pr-col-offset">
              <TextInput
                label="Observaciones"
                getFieldDecorator={getFieldDecorator}
                name="observations"
                placeholder="Introduzca observaciones"
              />
            </Col>

            {/* Rango de temperatura */}
            <Col xs={24} md={5} className="pr-col pr-col-offset">
              <SelectInput
                getFieldDecorator={getFieldDecorator}
                label="Rango de temperatura"
                name="temperatureRangeID"
                options={searchOptions.tempRangeList}
                placeholder="Seleccione un rango de temperatura..."
                labelInValue
                preLoadedData
                required
              />
            </Col>

            {/* Nuevo DatePicker */}
            <Col xs={24} md={5} className="pr-col pr-col-offset">
              <FarmaDateTimePicker
                getFieldDecorator={getFieldDecorator}
                name="preparationDate"
              />
            </Col>
          </>
        ) : (
          <>
            {/* Versión original */}
            <Col xs={24} md={7} className="pr-col">
              <TextInput
                label="Referencia del cliente"
                getFieldDecorator={getFieldDecorator}
                name="clientReference"
                placeholder="Introduzca una referencia de cliente"
              />
            </Col>
            <Col xs={24} md={7} className="pr-col pr-col-offset">
              <TextInput
                label="Observaciones"
                getFieldDecorator={getFieldDecorator}
                name="observations"
                placeholder="Introduzca observaciones"
              />
            </Col>
            <Col xs={24} md={7} className="pr-col pr-col-offset">
              <SelectInput
                getFieldDecorator={getFieldDecorator}
                label="Rango de temperatura"
                name="temperatureRangeID"
                options={searchOptions.tempRangeList}
                placeholder="Seleccione un rango de temperatura..."
                labelInValue
                preLoadedData
                required
              />
            </Col>
          </>
        )}
      </Row>

      <Row
        type="flex"
        justify="space-between"
        gutter={[16, 16]}
        className="pr-grid-row pr-conditional-row"
      >
        <Col xs={24} md={7} className="pr-col checkboxes-column">
          {[
            { name: "electronicDelivery", label: "Prueba entrega electrónica" },
            {
              name: "addresseeExclusiveDelivery",
              label: "Entrega exclusiva al destinatario",
            },
            { name: "declaredValue", label: "Valor declarado" },
            { name: "paymentOnDelivery", label: "Envío contrarreembolso" },
          ].map((checkbox) => (
            <CheckboxInput
              key={checkbox.name}
              getFieldDecorator={getFieldDecorator}
              setFieldsValue={setFieldsValue}
              name={checkbox.name}
              label={checkbox.label}
              initialValue={shipmentDetails?.[checkbox.name]}
              callback={
                ["declaredValue", "paymentOnDelivery"].includes(checkbox.name)
                  ? handleShipmentDetails
                  : undefined
              }
            />
          ))}
        </Col>

        <Col xs={24} md={7} className="pr-col pr-col-offset">
          {shipmentDetails?.declaredValue ? (
            <TextInput
              label="Importe valor declarado (céntimos de €)"
              getFieldDecorator={getFieldDecorator}
              name="declaredValueAmount"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 1125"
              pattern={/^\d+$/}
              patternMessage="Valor no válido."
            />
          ) : (
            <div className="pr-empty-slot" />
          )}
        </Col>

        <Col xs={24} md={7} className="pr-col pr-col-offset">
          {shipmentDetails?.paymentOnDelivery ? (
            <TextInput
              label="Importe envío contrarreembolso (céntimos de €)"
              getFieldDecorator={getFieldDecorator}
              name="paymentOnDeliveryAmount"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 385"
              pattern={/^\d+$/}
              patternMessage="Valor no válido."
            />
          ) : (
            <div className="pr-empty-slot" />
          )}
        </Col>
      </Row>
    </>
  );
}
